var _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 149,
    viewBox: "0 0 148 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0625,
    cy: 74.3535,
    r: 73.9375,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0609,
    cy: 74.3522,
    r: 62.3392,
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 100,
    fill: "white",
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: "70px"
  }, "B$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnd);
export default __webpack_public_path__ + "static/media/bnd.90c18cb14db579b42a47af222d506013.svg";
export { ForwardRef as ReactComponent };